webpackJsonp([91879571592643],{

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Forms: Material UI'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'WARNING! This section is a placeholder. Apologies while it gets sorted out.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Documentation for the Material UI implementation of Lore Forms'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/forms/material-ui/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'Libraries'
	          ),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'lore-react-forms-material-ui', url: '/forms/material-ui/lore-react-forms-material-ui/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'lore-hook-dialog-material-ui', url: '/forms/material-ui/lore-hook-dialog-material-ui/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'lore-hook-forms-material-ui', url: '/forms/material-ui/lore-hook-forms-material-ui/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'lore-hook-dialogs-material-ui', url: '/forms/material-ui/lore-hook-dialogs-material-ui/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'lore-react-forms-material-ui'
	          ),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'fields', url: '/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'lore-hook-forms-material-ui'
	          ),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - wizard', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - wizard', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - wizard', url: '/' }),
	          _react2.default.createElement(
	            'li',
	            { className: 'doc-section' },
	            'lore-hook-dialogs-material-ui'
	          ),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'create - wizard', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'update - wizard', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - optimistic', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - overlay', url: '/' }),
	          _react2.default.createElement(_NavLinkPlaceholder2.default, { title: 'destroy - wizard', url: '/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Material = __webpack_require__(305);
	
	var _Material2 = _interopRequireDefault(_Material);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Material2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the future, this page will document the Material UI version of the forms and dialogs libraries.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'For now, this page is simply a placeholder'
	      ),
	      ', and all the navigation in the sidebar on the right is simply a reference to which libraries exist, and what those libraries contain.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once this documentation exists, an email will be sent out as an announcement.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-material-ui-index-js-9133a67fdfc66f541301.js